import { ajuda as ajudaDeAftercare } from './ajuda/aftercare';
import { ajuda as ajudaDeBrokers } from './ajuda/brokers';
import { ajuda as ajudaComum } from './ajuda/comum';
import { ajuda as ajudaDeCounterparties } from './ajuda/counterparties';
import { ajuda as ajudaDeDocuments } from './ajuda/documents';
import { ajuda as ajudaDeGeneration } from './ajuda/generation';
import { ajuda as ajudaDeInsureds } from './ajuda/insureds';
import { ajuda as ajudaDeIntegrations } from './ajuda/integrations';
import { ajuda as ajudaDeLogs } from './ajuda/logs';
import { ajuda as ajudaDeOperations } from './ajuda/operations';
import { ajuda as ajudaDeParameters } from './ajuda/parameters';
import { ajuda as ajudaDePolicyholders } from './ajuda/policyholders';
import { ajuda as ajudaDePortfolio } from './ajuda/portfolio';
import { ajuda as ajudaDePricing } from './ajuda/pricing';
import { ajuda as ajudaDeParametrization } from './ajuda/parametrization';
import { ajuda as ajudaDePipes } from './ajuda/pipes';
import { ajuda as ajudaDePlatform } from './ajuda/platform';
import { ajuda as ajudaDeReports } from './ajuda/reports';
import { ajuda as ajudaDeSettings } from './ajuda/settings';
import { ajuda as ajudaDeTemplates } from './ajuda/templates';
import { ajuda as ajudaDeTerms } from './ajuda/terms';
import { ajuda as ajudaDeUsers } from './ajuda/users';

/**
 * Textos do icone de ajuda (i) dos campos de formulario.
 *
 * Os textos ficam aqui, e nao em cada formulario, por dois motivos. Primeiro, um
 * so lugar para revisar o que a tela ensina: o texto precisa dizer o que o servidor
 * faz, e uma copia espalhada em vinte arquivos divergiria na primeira mudanca de
 * regra. Segundo, o campo encontra a propria ajuda pelo rotulo e pela tela, e por
 * isso ganhar ajuda nao exige mexer no formulario.
 *
 * A chave de fora e a rota da tela (a mais longa que cobre o endereco vence, e "*"
 * vale para todas); a de dentro e o rotulo exato do campo. Um teste confere que toda
 * rota existe no menu e todo rotulo existe em algum formulario, para que uma
 * mudanca de rotulo nao deixe a ajuda orfa sem ninguem notar.
 *
 * Cada modulo escreve a sua em `ajuda/<modulo>.ts`, com o nome da pasta do modulo em
 * `features/`, e este arquivo so as junta: o pacote que mexe num modulo toca so o
 * arquivo dele. Rota que aparece em dois modulos e recusada pelo teste.
 */
export const ajudaDosCampos: Record<string, Record<string, string>> = {
  ...ajudaComum,
  ...ajudaDeOperations,
  ...ajudaDePolicyholders,
  ...ajudaDeInsureds,
  ...ajudaDeBrokers,
  ...ajudaDePricing,
  ...ajudaDeParametrization,
  ...ajudaDeParameters,
  ...ajudaDePortfolio,
  ...ajudaDeSettings,
  ...ajudaDeTemplates,
  ...ajudaDeIntegrations,
  ...ajudaDeUsers,
  ...ajudaDeDocuments,
  ...ajudaDeGeneration,
  ...ajudaDeTerms,
  ...ajudaDePipes,
  ...ajudaDePlatform,
  ...ajudaDeReports,
  ...ajudaDeAftercare,
  ...ajudaDeLogs,
  ...ajudaDeCounterparties,
};

/** Rota mais longa do dicionario que cobre o endereco atual. */
function rotasQueCobrem(rota: string): string[] {
  return Object.keys(ajudaDosCampos)
    .filter(
      (chave) =>
        chave !== '*' &&
        (rota === chave || (chave !== '/' && rota.startsWith(`${chave}/`))),
    )
    .sort((a, b) => b.length - a.length);
}

/**
 * Texto de ajuda do campo, ou undefined quando nao ha.
 *
 * A tela tem precedencia sobre o geral: "Comissao (%)" quer dizer coisas
 * diferentes no cadastro do corretor e na operacao.
 */
export function textoDeAjuda(rota: string, rotulo: string): string | undefined {
  for (const chave of rotasQueCobrem(rota)) {
    const texto = ajudaDosCampos[chave]?.[rotulo];
    if (texto) return texto;
  }
  return ajudaDosCampos['*']?.[rotulo];
}
